import { ShopModelCarousal } from "../../constants/jsonConstant";
import { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import Modal from "react-bootstrap/Modal";
import { images } from "../../constants";
import url from "../../config/axios"
// import "./fooddataModel.css";
import { Row, Col, Tabs, Tab, Card, Container, Button } from "react-bootstrap";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Rating from "@mui/material/Rating";
import { RatingStar } from "../../constants/jsonConstant";
import BackArrow from "../../components/backArrow";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./style.css";
import { getAsset, formatCurrencyCode } from "../../helpers/helper";
import moment from "moment";
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ShareIcon from '@mui/icons-material/Share';
import ClearIcon from '@mui/icons-material/Clear';
import { SuccessNotify } from "../../constants/tostify";
import dummyezi from "../../assets/images/dummy/dummyezi.png";

const Updatefoodform = ({ Open, setOpen }) => {
  const [increase, setIncrease] = useState(1);
  const { name } = useSelector((state) => state.user);
  const [fooddata, setFooddata] = useState();
  
  useEffect(() => {
    url.get(`fooditem/id?id=${Open}`).then((response) => {
      console.log("abc", response)
      setFooddata(response?.data?.data)
    });
  }, []);
  
  console.log("foooodyyy", fooddata)
  const [value] = useState(5);
  const [valueone] = useState(4);
  const [valuetwo] = useState(3);
  const [valuethree] = useState(2);
  const [valuefour] = useState(1);

  const location = useLocation();

  // Combined and improved effect: Runs after fooddata is available and modal is open
  useEffect(() => {
    if (Open && fooddata) {
      const imgs = document.querySelectorAll('.image-gallery-image');
      imgs.forEach((element) => {
        element.setAttribute('crossorigin', 'anonymous');
      });

      const thumimgs = document.querySelectorAll('.image-gallery-thumbnail-image');
      thumimgs.forEach((element) => {
        element?.setAttribute('crossorigin', 'anonymous');
      });
    }
  }, [Open, fooddata]); // Add fooddata as dependency to trigger after data fetch

  const ShopModelCarousal =
    fooddata?.images && fooddata.images.length > 0
      ? fooddata.images.map((image, index) => ({
          id: index + 1,
          original: getAsset(image),
          thumbnail: getAsset(image),
        }))
      : [
          {
            id: 1,
            original: dummyezi,
            thumbnail: dummyezi,
          },
        ];

  const handleShare = () => {
    navigator.clipboard.writeText(window.location.href);
    SuccessNotify("Link copied to clipboard!");
  };

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={Open}
        onHide={() => setOpen(false)}
      >
        <Modal.Body className="">
          <div className="d-flex justify-content-end">
            <ClearIcon fontSize="large"  onClick={() => setOpen(false)} style={{cursor:"pointer", color:"red"}}/>
          </div>
          <div className="ps-4">
            <p>Posted At : {moment(fooddata?.createdAt).format("DD-MM-YYYY")}</p>
          </div>
          <Row>
            <Col lg="6">
              <div className="row ">
                <ImageGallery
                  showPlayButton={false}
                  showFullscreenButton={false}
                  className="mb-0"
                  items={ShopModelCarousal}
                  onErrorImageURL={dummyezi}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className=" ps-4 pe-4 pt-4 pb-1 bg-vilot View-Model-Shadow ">
                <div className="d-flex justify-content-end">
                  {/* <button className="text-white bg-blue share_font">share</button> */}
                  
                  <Button variant="primary" onClick={handleShare}>
                    <ShareIcon fontSize="small" /> Share
                  </Button>
                </div>

                <h4 className="fw-bold">{fooddata?.dishname}</h4>
                <p className="col-10 fw-lighter">
                  {fooddata?.description}
                </p>
                <div>
                  <h4>price</h4>
                  <h3 className="font-blue">{formatCurrencyCode(fooddata?.currency)}&nbsp;{fooddata?.price}</h3>
                </div>
                <div>
                  <p className="mb-0">Contact us on</p>
                  {/* <p className="mb-0 pt-2 pb-2">{name?.email}</p> */}
                  <p className="mb-0">{name?.phonenumber}</p>
                </div>

                {/* <div className="bg-white quantityBox mt-2 mb-2  pe-2 ps-2 w-25 d-flex align-items-center ">
                  <div>
                    <p className="mb-0 pe-1">QTY:</p>
                  </div>
                  <div>
                    <p className="mb-0 pe-1">{increase}</p>
                  </div>

                  <div>
                    <div className="d-flex flex-column align-items-center ">
                      <ExpandLessIcon
                        fontSize="small"
                        onClick={() => setIncrease(increase + 1)}
                      />
                      <ExpandMoreIcon
                        fontSize="small"
                        onClick={() => setIncrease(increase - 1)}
                      />
                    </div>
                  </div>
                </div> */}

                <div className="pt-3 cursor">


                  <button
                    className=" d-flex align-items-center justify-content-center mt-5 mb-0 border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 w-75 text-white"
                    onClick={""}
                  >
                    <ChatBubbleIcon fontSize="small" />
                    <span className="ps-2 mb-1">Message</span>
                  </button>

                </div>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Updatefoodform;